export interface StaminaBarStyle {
  ratio: number;
  fillColor: number;
  fillAlpha: number;
  glowColor: number;
  glowAlpha: number;
  trackColor: number;
  trackAlpha: number;
}

export const STAMINA_LOW_RATIO = 0.25;

export function getStaminaRatio(stamina: number, maxStamina: number): number {
  if (!Number.isFinite(stamina) || !Number.isFinite(maxStamina)) {
    return 0;
  }
  if (maxStamina <= 0) {
    return 0;
  }
  return Math.min(1, Math.max(0, stamina / maxStamina));
}

export function getStaminaBarStyle(
  stamina: number,
  maxStamina: number,
  insufficientFeedback = false,
): StaminaBarStyle {
  const ratio = getStaminaRatio(stamina, maxStamina);
  const low = ratio < STAMINA_LOW_RATIO;

  if (insufficientFeedback) {
    return {
      ratio,
      fillColor: 0xd7efe7,
      fillAlpha: 0.72,
      glowColor: 0xffffff,
      glowAlpha: 0.34,
      trackColor: 0x07101d,
      trackAlpha: 0.62,
    };
  }

  if (low) {
    return {
      ratio,
      fillColor: 0x9aa89f,
      fillAlpha: 0.58,
      glowColor: 0x9aa89f,
      glowAlpha: 0.12,
      trackColor: 0x07101d,
      trackAlpha: 0.54,
    };
  }

  return {
    ratio,
    fillColor: 0x6ae3b1,
    fillAlpha: 0.86,
    glowColor: 0xb3ffd9,
    glowAlpha: 0.22,
    trackColor: 0x07101d,
    trackAlpha: 0.48,
  };
}

export function smoothStaminaRatio(
  currentRatio: number | null,
  targetRatio: number,
  deltaMs: number,
): number {
  const target = Math.min(1, Math.max(0, targetRatio));
  if (currentRatio === null || !Number.isFinite(currentRatio)) {
    return target;
  }
  const smoothing = 1 - Math.exp(-Math.max(0, deltaMs) / 120);
  return currentRatio + (target - currentRatio) * smoothing;
}
